import WeekHeader from './WeekEvent.view';

export default WeekHeader;
